import { omit, sortBy } from 'lodash';
import { 
  LayoutAreaInGroup, 
  LayoutAreaInFields,
  LayoutGroupsModel,
  usedFieldModel,
  LayoutFieldItem,
  unusedAreaFieldModel
} from '../model/layout';

// 布局数据扁平处理
export const transformLayoutData = (data: LayoutAreaInGroup[]): LayoutAreaInFields[] => {
  return data.map(area => ({
    ...omit(area, ['groupList']),
    fields: transformLayoutGroup(area.groupList)
  })) || []; 
};

export const transformLayoutGroup = (groups: LayoutGroupsModel[]): LayoutFieldItem[] => {
  const groupsRes = (groups || []).map(group => 
    (group.issueFieldOrdinateVOList || []).map(l => l.issueFieldInfoVo).flat()
  ).flat();
  return sortBy(groupsRes || [], ['ordinate']);
};

// 未使用字段列表格式转换为布局字段格式
export const transFormToUsedField = (fields: unusedAreaFieldModel[]): LayoutFieldItem[] => {
  const defaultTemplate = getLayoutFieldTemplate();
  return fields.map(f => ({
    fixed: 0,
    ...defaultTemplate,
    ...f,
    source: f.source || 'unused'
  }));
};

// 获取布局差异字段列表模板
const getLayoutFieldTemplate = (): usedFieldModel => {
  return {
    abscissa: 0,
    areaId: 0,
    changeArea: 1,
    showed: 1,
    ordinate: 0,
    soleFlag: 1,
    requiredFlag: 0,
    width: 100,
    groupOrder: 0,
    startPoint: 0
  };
};

// 创建新字段后格式化为布局字段结构
export const newDataToUsedField = (param: {
  controlCode: string;
  customFieldId: number;
  customFieldName: string;
  fieldCode?: string;
  fieldProjectId: string | number;
  issueTypeId: number;
  tips: string | null;
}): LayoutFieldItem => {
  const layoutFieldTemplate = getLayoutFieldTemplate();
  return {
    ...layoutFieldTemplate,
    ...param,
    fieldCode: param.fieldCode || `customfield_${param.customFieldId}`,
    couldModifyRequired: param.couldModifyRequired || 1,
    createTime: new Date().getTime(),
    expressionRelateFieldList: param.expressionRelateFieldList || [],
    fieldDescription: null,
    source: param.source || 'custom',
    tips: param.tips || null,
    fixed: 0
  };
};